import React from 'react';
import PropTypes from 'prop-types';

import { apiHost } from '../../../utils/request';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button } from './css';

const downloadQuote = (locale, orderData) => {
  const { id } = orderData;
  window.open(`${apiHost}/orders/${id}/business-app-contract`, '_blank');
  // if (productInOrderFor === 'ESChat') {
  //   window.open(`${apiHost}/orders/${id}/ba-eschat-contract`, '_blank');
  // } else {
  //   window.open(`${apiHost}/orders/${id}/quote-pdf?lang=${locale}`, '_blank');
  // }
};

const DownloadQuote = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const staticLabels = localizedStrings.BUSINESS_APP_ORDERS;
  const { saveQuote } = staticLabels;
  return (
    <Button onClick={() => downloadQuote(orderData.locale, orderData)}>
      {saveQuote}
    </Button>
  );
};

DownloadQuote.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default DownloadQuote;
